<template>
  <div class="t-menu" @focusout="close" tabindex="">
    <span class="t-menu__activator" @click="toggle">
      <slot name="activator"></slot>
    </span>

    <div
      class="t-menu__content"
      :class="[
        `t-menu__content--align-${align}`,
        { 't-menu__content--open': open }
      ]"
      @click="dismiss"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { menuAlignOptions } from '../../enums';

export default {
  name: 't-menu',

  props: {
    align: {
      type: String,
      default: menuAlignOptions.BOTTOM_LEFT,
      validator: (value) => Object.values(menuAlignOptions).includes(value),
    },
  },

  data() {
    return {
      open: false,
    };
  },

  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },

    dismiss() {
      this.open = false;
    },

    close(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
      }
    },
  },
};
</script>
